/* Extracted from snippets/cart-drawer.liquid (lines 2272-2685 of the 20 Oct 2026 live copy) by checks/split_inline_js.py.
   Same code, same position in the page; now a cached asset instead of inline HTML. */
      (function () {
        var drawer = document.querySelector('[data-cart-drawer]');
        if (!drawer) return;
        var link = drawer.querySelector('[data-checkout-link]');
        var noteInput = drawer.querySelector('[data-note-input]');
        var notePending = null;   
        if (link) {
          link.addEventListener('click', function (e) {
            if (window.TheColor && window.TheColor.Cart) {
              window.TheColor.Cart.beginCheckout();
            }
            
            if (notePending !== null && window.TheColor && window.TheColor.Cart && window.TheColor.Cart.setNote) {
              e.preventDefault();
              var href = link.href;
              var went = false;
              var go = function () { if (went) return; went = true; window.location.href = href; };
              var n = notePending;
              notePending = null;
              window.TheColor.Cart.setNote(n).then(go, go);
              setTimeout(go, 2500);
            }
          });
        }

        
        var wallets = drawer.querySelector('[data-cart-wallets]');
        if (wallets) {
          wallets.addEventListener('click', function () {
            if (window.TheColor && window.TheColor.Cart) window.TheColor.Cart.beginCheckout();
            
            if (notePending !== null) saveNote();
          }, true);
        }

        
        var walletSlot = drawer.querySelector('[data-cart-wallets-slot]');
        
        var walletsDockMQ = window.matchMedia ? window.matchMedia('(max-width: 768px) and (min-height: 501px) and (max-height: 760px)') : null;
        function dockWallets() {
          var body = drawer.querySelector('[data-cart-drawer-body]');
          if (!wallets || !body || !walletsDockMQ || !walletsDockMQ.matches) return;
          if (wallets.parentNode !== body) body.appendChild(wallets);
        }
        function mountWallets() {
          var tpl = walletSlot && walletSlot.querySelector('template[data-cart-wallets-tpl]');
          
          if (!tpl || !drawer.querySelector('[data-cart-item]')) return;
          dockWallets();
          walletSlot.appendChild(tpl.content.cloneNode(true));
          walletSlot.removeChild(tpl);
        }
        if (walletSlot) {
          document.addEventListener('cart:open', mountWallets);
          
          document.addEventListener('cart:updated', function () {
            if (drawer.classList.contains('is-open')) mountWallets();
          });
          var idleMount = function () {
            if (!drawer.querySelector('[data-cart-item]')) return;
            if ('requestIdleCallback' in window) window.requestIdleCallback(mountWallets, { timeout: 4000 });
            else setTimeout(mountWallets, 2000);
          };
          if (document.readyState === 'complete') idleMount();
          else window.addEventListener('load', idleMount, { once: true });
        }

        
        var noteWrap = drawer.querySelector('[data-cart-note]');
        var noteToggle = drawer.querySelector('[data-note-toggle]');
        var noteField = drawer.querySelector('[data-note-field]');
        var noteStatus = drawer.querySelector('[data-note-status]');
        var noteTimer = null;
        function saveNote() {
          clearTimeout(noteTimer);
          if (notePending === null || !window.TheColor || !window.TheColor.Cart || !window.TheColor.Cart.setNote) return;
          var n = notePending;
          notePending = null;
          if (noteStatus) noteStatus.textContent = 'Saving…';
          window.TheColor.Cart.setNote(n).then(function () {
            if (noteStatus) noteStatus.textContent = n ? 'Saved — it goes through to checkout with your order.' : 'Note removed.';
            
            var pageNote = document.querySelector('[data-section-type="cart-main"] [name="note"]');
            if (pageNote && pageNote !== document.activeElement) pageNote.value = n;
          }, function () {
            notePending = n;
            if (noteStatus) noteStatus.textContent = 'Couldn’t save your note — check your connection and try again.';
          });
        }
        if (noteToggle && noteField && noteInput) {
          noteToggle.addEventListener('click', function () {
            var open = noteToggle.getAttribute('aria-expanded') !== 'true';
            noteToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
            noteField.hidden = !open;
            
            if (open) noteInput.focus({ preventScroll: true });
            scheduleCue();
          });
          noteInput.addEventListener('input', function () {
            notePending = noteInput.value;
            if (noteStatus) noteStatus.textContent = '';
            clearTimeout(noteTimer);
            noteTimer = setTimeout(saveNote, 900);
          });
          noteInput.addEventListener('blur', saveNote);
          
          document.addEventListener('cart:updated', function (e) {
            var c = e.detail && e.detail.cart;
            if (!c || notePending !== null || document.activeElement === noteInput) return;
            if (typeof c.note === 'string' && c.note !== noteInput.value) noteInput.value = c.note;
          });
          
          document.addEventListener('cart:note', function (e) {
            var n = e.detail && e.detail.note;
            if (typeof n !== 'string' || notePending !== null || document.activeElement === noteInput) return;
            if (n !== noteInput.value) noteInput.value = n;
          });
        }

        
        var discountWrap = drawer.querySelector('[data-cart-discount]');
        var toggle = drawer.querySelector('[data-discount-toggle]');
        var input = drawer.querySelector('[data-discount-input]');
        var applyBtn = drawer.querySelector('[data-discount-apply]');
        var msg = drawer.querySelector('[data-discount-msg]');
        var collapseTimer = null;

        function setInvalid(on) {
          if (!input) return;
          input.classList.toggle('tc-input--error', !!on);
          if (on) input.setAttribute('aria-invalid', 'true');
          else input.removeAttribute('aria-invalid');
        }

        function setExpanded(open, focusInput) {
          if (!discountWrap) return;
          clearTimeout(collapseTimer);
          discountWrap.setAttribute('data-expanded', open ? 'true' : 'false');
          if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          
          if (open && focusInput && input) input.focus({ preventScroll: true });
          if (!open) {
            
            if (msg) msg.textContent = '';
            setInvalid(false);
            if (applyBtn && applyBtn.textContent !== 'Checking…') {
              applyBtn.disabled = false;
              applyBtn.textContent = 'Apply';
            }
          }
          scheduleCue();
        }

        if (toggle) {
          toggle.addEventListener('click', function () {
            var open = discountWrap.getAttribute('data-expanded') !== 'true';
            setExpanded(open, open);
          });
        }

        
        (function () {
          var vv = window.visualViewport;
          if (!vv) return;
          var typing = false;
          function isField(el) { return !!el && el.matches && el.matches('input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]), textarea'); }
          function reset() {
            drawer.style.height = '';
            drawer.style.top = '';
            drawer.classList.remove('tc-kb-open');
          }
          function fit() {
            if (!typing) return;
            var kb = window.innerHeight - vv.height;
            if (kb < 80 || Math.abs(vv.scale - 1) > 0.01) { reset(); return; }
            drawer.style.height = Math.round(vv.height) + 'px';
            drawer.style.top = Math.round(vv.offsetTop) + 'px';
            drawer.classList.add('tc-kb-open');
            var f = document.activeElement;
            
            if (f && drawer.contains(f) && !f.closest('[data-cart-footer]') && f.scrollIntoView) {
              try { f.scrollIntoView({ block: 'nearest' }); } catch (e) {}
            }
          }
          drawer.addEventListener('focusin', function (e) {
            if (!isField(e.target)) return;
            typing = true;
            fit();
            
            setTimeout(fit, 150);
            setTimeout(fit, 400);
          });
          drawer.addEventListener('focusout', function () {
            setTimeout(function () {
              if (isField(document.activeElement) && drawer.contains(document.activeElement)) return;
              typing = false;
              reset();
            }, 120);
          });
          vv.addEventListener('resize', fit);
          vv.addEventListener('scroll', fit);
        })();

        function money(p) {
          var U = window.TheColor && window.TheColor.utils;
          return U && U.formatMoney ? U.formatMoney(p) : '£' + (p / 100).toFixed(2);
        }

        if (applyBtn && input) {
          applyBtn.addEventListener('click', function () {
            
            var code = input.value.trim().replace(/\s+/g, '').toUpperCase();
            if (!code) {
              
              clearTimeout(collapseTimer);
              if (msg) { msg.textContent = ''; msg.style.color = ''; }
              setInvalid(false);
              input.focus({ preventScroll: true });
              return;
            }
            var Cart = window.TheColor && window.TheColor.Cart;
            if (!Cart || !Cart.applyDiscount) return;
            clearTimeout(collapseTimer);
            setInvalid(false);
            
            if (document.activeElement === applyBtn && toggle) toggle.focus();
            applyBtn.disabled = true;
            applyBtn.textContent = 'Checking…';
            if (msg) { msg.textContent = ''; msg.style.color = ''; }
            
            Cart.applyDiscount(code).then(function (res) {
              var cart = res.cart || {};
              if (res.state === 'applied') {
                if (msg) {
                  
                  var showSavings = !!(window.theme && window.theme.showSetSavings);
                  msg.textContent = code + ' applied' + (showSavings && cart.total_discount > 0 ? ' — you’re saving ' + money(cart.total_discount) : '') + '.';
                  
                  msg.style.color = 'var(--color-success-text)';
                }
                applyBtn.textContent = 'Applied';
                input.value = '';
                
                collapseTimer = setTimeout(function () {
                  var hadFocus = discountWrap.contains(document.activeElement);
                  setExpanded(false);
                  if (hadFocus && toggle) toggle.focus();
                }, 2600);
                return;
              }
              if (res.state === 'free-shipping' || res.state === 'account-only') {
                
                if (msg) {
                  msg.textContent = res.state === 'free-shipping'
                    ? code + ' will be applied at checkout.'
                    : code + ' saved for checkout — see the note above.';
                  msg.style.color = '';
                }
                input.value = '';
                applyBtn.disabled = false;
                applyBtn.textContent = 'Apply';
                collapseTimer = setTimeout(function () {
                  var hadFocus = discountWrap.contains(document.activeElement);
                  setExpanded(false);
                  if (hadFocus && toggle) toggle.focus();
                }, 2600);
                return;
              }
              if (msg) {
                msg.textContent = '“' + code + '” can’t be used on this basket' +
                  (res.kept ? ' — keeping ' + res.kept + '.' : '.');
                msg.style.color = 'var(--color-error-text, #991b1b)';
              }
              setInvalid(true);
              applyBtn.disabled = false;
              applyBtn.textContent = 'Apply';
            }).catch(function () {
              if (msg) {
                msg.textContent = 'Couldn’t check the code just now — you can still enter it at checkout.';
                msg.style.color = '';
              }
              applyBtn.disabled = false;
              applyBtn.textContent = 'Apply';
            });
          });

          
          document.addEventListener('cart:discount-removed', function () {
            clearTimeout(collapseTimer);
            setInvalid(false);
            input.value = '';
            applyBtn.disabled = false;
            applyBtn.textContent = 'Apply';
          });

          input.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
              e.preventDefault();
              applyBtn.click();
            }
          });

          
          input.addEventListener('input', function () {
            clearTimeout(collapseTimer);
            
            if (input.getAttribute('aria-invalid') === 'true' && msg) { msg.textContent = ''; msg.style.color = ''; }
            setInvalid(false);
            if (applyBtn.disabled && applyBtn.textContent !== 'Checking…') {
              applyBtn.disabled = false;
              applyBtn.textContent = 'Apply';
            }
          });
        }

        
        var cueBody = drawer.querySelector('[data-cart-drawer-body]');
        var cueFooter = drawer.querySelector('[data-cart-footer]');
        var cue = drawer.querySelector('[data-scroll-cue]');
        var cueRaf = 0;
        function updateScrollCue() {
          cueRaf = 0;
          if (!cueBody || !cueFooter || !cue) return;
          var more = cueBody.scrollHeight - cueBody.scrollTop - cueBody.clientHeight > 24;
          cueFooter.setAttribute('data-more-below', more ? 'true' : 'false');
          var strip = cueBody.querySelector('[data-cart-upsell]');
          var stripLive = !!(strip && strip.offsetHeight > 0 && strip.querySelector('[data-upsell-card]'));
          var showCue = false;
          if (stripLive) {
            var fold = cueBody.getBoundingClientRect().bottom;
            showCue = strip.getBoundingClientRect().top >= fold - 4;
          }
          if (cue.hidden === showCue) cue.hidden = !showCue;
        }
        function scheduleCue() {
          
          if (document.hidden || typeof requestAnimationFrame !== 'function') { updateScrollCue(); return; }
          if (!cueRaf) cueRaf = requestAnimationFrame(updateScrollCue);
        }
        if (cueBody && cue) {
          cueBody.addEventListener('scroll', scheduleCue, { passive: true });
          cue.addEventListener('click', function () {
            var strip = cueBody.querySelector('[data-cart-upsell]');
            
            var target = (strip && strip.offsetHeight > 0)
              ? Math.max(strip.offsetTop + strip.offsetHeight - cueBody.clientHeight + 8, 0)
              : cueBody.scrollHeight;
            var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            cueBody.scrollTo({ top: target, behavior: reduce ? 'auto' : 'smooth' });
          });
          
          document.addEventListener('cart:open', function () { setTimeout(scheduleCue, 400); });
          document.addEventListener('cart:updated', function () { setTimeout(scheduleCue, 450); });
          window.addEventListener('resize', scheduleCue, { passive: true });
          if (typeof MutationObserver === 'function') {
            new MutationObserver(scheduleCue).observe(cueBody, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'hidden'] });
          }
          if (typeof ResizeObserver === 'function') {
            new ResizeObserver(scheduleCue).observe(cueBody);
          }
          updateScrollCue();
        }
      })();
